import { Box, Button, Checkbox, CircularProgress, Collapse, List, ListItemButton, ListItemText } from "@mui/material";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material"
// import ArgonBox from "components/ArgonBox";
import PropTypes from "prop-types";
import MDInput from "components/MDInput";
import { useMaterialUIController } from "context";
import http from "Utils/api2";
import InfiniteScroll from "react-infinite-scroll-component";
import SkLoading from "components/SkLoading";
import { useDispatch } from "react-redux";
import { handleAlert } from "redux/festures/alertSlice";

function useOutsideClosing(ref, setLocationSearchSwitch) {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setLocationSearchSwitch(false)
            }
        }
        // Bind the event listener
        document.addEventListener("mouseup", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mouseup", handleClickOutside);
        };
    }, [ref]);
}

const InfiniteApnaSelect = ({ fetchApi, value, name, onChange, origin, valueKey, nameKey, isSimpleArray, collpaseHeight, multi, fetchApiParams, defaultName, ...rest }) => {
    const dispatch = useDispatch()
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const [openDropDown, setOpenDropDown] = useState(false)
    const [valueName, setValueName] = useState([])
    const [search, setSearch] = useState('')
    const [data, setData] = useState(null)
    const [loader, setLoader] = useState(false)
    const [filterData, setFilterData] = useState(null)
    const [hasMore, setHasMore] = useState(false)
    const [page, setPage] = useState(1)
    const outSideClose = useRef(null)
    useOutsideClosing(outSideClose, setOpenDropDown);


    // const filterData = useMemo(() => {
    //     if (search && data && data?.length) {
    //         if (!isSimpleArray) return data?.filter(e => e[nameKey].toLowerCase()?.includes(search?.toLowerCase()))
    //         else if (isSimpleArray) return data?.filter(e => e.toLowerCase()?.includes(search?.toLowerCase()))
    //         else return []
    //     }
    // }, [search])

    useEffect(() => {
        setData(null)
        setFilterData(null)
        if (!fetchApi || fetchApi.includes("//")) {
            setData([])
            setFilterData(null)
            setLoader(false)
            setHasMore(false)
            return
        }
        setLoader(true)
        if (search.length) {
            http(`${process.env.REACT_APP_APII}${fetchApi}?page=1&search=${search}${fetchApiParams ? fetchApiParams : ''}`)
                .then(result => {
                    const fetchedData = result?.data?.data || [];
                    const totalPages = result?.data?.page || 1;
                    const uniqueFetched = Array.from(
                        new Map(fetchedData.map(item => [item[nameKey] ? String(item[nameKey]).trim().toLowerCase() : (item[valueKey] || item._id), item])).values()
                    );
                    const filtered = uniqueFetched.filter((elm) =>
                        elm[nameKey] ? elm[nameKey]?.toLowerCase()?.includes(search?.toLowerCase()) : true
                    );
                    setFilterData(filtered);
                    setPage(1);
                    setHasMore(1 < totalPages);
                    setLoader(false);
                })
                .catch(err => {
                    dispatch(
                        handleAlert({
                            isOpen: true,
                            type: `error`,
                            msg: `${err.response?.data?.message}`,
                        })
                    );
                    setHasMore(false)
                    setLoader(false)
                })
        } else {
            setFilterData(null)
            http(`${process.env.REACT_APP_APII}${fetchApi}?page=1&search=${search}${fetchApiParams ? fetchApiParams : ''}`)
                .then(result => {
                    const fetchedData = result?.data?.data || [];
                    const totalPages = result?.data?.page || 1;
                    const uniqueFetched = Array.from(
                        new Map(fetchedData.map(item => [item[nameKey] ? String(item[nameKey]).trim().toLowerCase() : (item[valueKey] || item._id), item])).values()
                    );
                    setData(uniqueFetched);
                    setPage(1);
                    setHasMore(1 < totalPages);
                    setLoader(false)
                })
                .catch(err => {
                    dispatch(
                        handleAlert({
                            isOpen: true,
                            type: `error`,
                            msg: `${err.response?.data?.message}`,
                        })
                    );
                    setHasMore(false)
                    setLoader(false)
                })
        }
    }, [fetchApi, search, openDropDown])


    const fetchMore = () => {
        if (!fetchApi || fetchApi.includes("//")) return
        const nextPage = page + 1;
        http(`${process.env.REACT_APP_APII}${fetchApi}?page=${nextPage}&search=${search}${fetchApiParams ? fetchApiParams : ''}`)
            .then(result => {
                if (result?.data?.data?.length) {
                    const totalPages = result?.data?.page || 1;
                    if (search?.length) {
                        const combined = [...(filterData || []), ...result.data.data];
                        const uniqueCombined = Array.from(
                            new Map(combined.map(item => [item[nameKey] ? String(item[nameKey]).trim().toLowerCase() : (item[valueKey] || item._id), item])).values()
                        );
                        setFilterData(uniqueCombined);
                    } else {
                        const combined = [...(data || []), ...result.data.data];
                        const uniqueCombined = Array.from(
                            new Map(combined.map(item => [item[nameKey] ? String(item[nameKey]).trim().toLowerCase() : (item[valueKey] || item._id), item])).values()
                        );
                        setData(uniqueCombined);
                    }
                    setPage(nextPage);
                    setHasMore(nextPage < totalPages);
                } else setHasMore(false)
            })
            .catch(err => {
                toast.error(`An error occured - ${err.error || err.message || err}`, 2000)
                setHasMore(false)
            })
    }

    useEffect(() => {
        if (!isSimpleArray) {
            const rawArr = Array.isArray(value) ? value : (value ? [value] : []);
            const seenIds = new Set();
            const valArr = [];
            rawArr.forEach(v => {
                const id = typeof v === 'object' && v !== null ? String(v[valueKey] || v._id || v.id) : String(v);
                if (id && !seenIds.has(id)) {
                    seenIds.add(id);
                    valArr.push(v);
                }
            });

            if (multi) {
                const temp = [];
                valArr.forEach(v => {
                    if (typeof v === 'object' && v !== null && v[nameKey]) {
                        temp.push(v[nameKey]);
                    } else if (data && data?.length) {
                        const targetId = typeof v === 'object' && v !== null ? String(v[valueKey] || v._id) : String(v);
                        const item = data.find(e => String(e[valueKey]) === targetId);
                        if (item && item[nameKey]) temp.push(item[nameKey]);
                    }
                });
                const uniqueNames = [...new Set(temp)];
                if (uniqueNames?.length) setValueName(uniqueNames);
                else if (!data?.length) setValueName("");
            } else {
                if (!value) {
                    setValueName("");
                } else if (typeof value === 'object' && value !== null && value[nameKey]) {
                    setValueName(value[nameKey]);
                } else if (data && data?.length) {
                    const targetId = typeof value === 'object' && value !== null ? String(value[valueKey] || value._id) : String(value);
                    const item = data.find(e => String(e[valueKey]) === targetId);
                    if (item && item[nameKey]) setValueName(item[nameKey]);
                    else if (defaultName) setValueName(defaultName);
                } else if (defaultName) {
                    setValueName(defaultName);
                }
            }
        }
    }, [value, data, defaultName]);


    const handleClick = () => {
        setSearch('')
        setHasMore(true)
        setPage(1)
        setOpenDropDown(!openDropDown);
    };
    // console.log(value)
    return (
        <>
            <div style={{ marginBottom: "10px", width: '100%', position: 'realtive' }} ref={outSideClose}>
                <List>
                    <ListItemButton
                        {...rest}
                        sx={{
                            borderRadius: '10px',
                            border: '1px solid gainsboro',
                            padding: '.575rem 1.125rem'
                        }} onClick={handleClick}>
                        <ListItemText sx={({ palette: { dark, error, info, white } }) => ({
                            '& .MuiTypography-root': {
                                fontWeight: '500',
                                fontSize: "14px",
                                color: !darkMode ? dark.main : white.main,
                            }
                        })}
                            primary={isSimpleArray ? name : valueName && valueName?.length ? Array.isArray(valueName) ? valueName?.join(', ') : valueName : (value ? defaultName : "") || `Choose ${origin}`} />
                        {openDropDown ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse
                        in={openDropDown}
                        timeout="auto"
                        style={{
                            width: '100%',
                            border: '1px solid Silver',
                            margin: '0.5rem 0',
                            zIndex: '1000000',
                            borderRadius: "12px",
                            padding: "2%"
                        }}
                    >
                        <Box
                            id="scrollContainer"
                            sx={{
                                maxHeight: "300px",
                                overflowY: "auto",
                                position: "relative",
                            }}
                        >
                            <List component="div" disablePadding>
                                <Box sx={({ palette: { dark, error, info, white } }) => ({
                                    position: 'sticky', top: '0', backgroundColor: darkMode ? dark.main : white.main, zIndex: '1000', "& .MuiListItemText-root": {
                                        color: !darkMode ? dark.main : white.main,
                                    }
                                })}>
                                    <ListItemText sx={({ palette: { dark, error, info, white } }) => ({
                                        display: 'block', '& .MuiTypography-root': {
                                            fontWeight: '500',
                                            fontSize: "14px",
                                            color: !darkMode ? dark.main : white.main,
                                        }
                                    })} primary={'Search'} />
                                    <ListItemButton onClick={() => {
                                    }} sx={{ pl: 1 }}>
                                        <MDInput
                                            className="form-control"
                                            type="text"
                                            fullWidth
                                            data-bs-binded-element="#phone-value"
                                            data-bs-unset-value="Not specified"
                                            onChange={(e) => setSearch(e.target.value)}
                                            disabled={loader}
                                            value={search}
                                        />
                                    </ListItemButton>
                                </Box>
                                <hr />
                                {loader ? <SkLoading /> : <InfiniteScroll
                                    scrollableTarget="scrollContainer"
                                dataLength={search?.length ? filterData?.length || 0 : data?.length || 0}
                                // className={style.infiniteScroll}
                                next={fetchMore}
                                hasMore={hasMore}
                                loader={<CircularProgress color="primary" size={20} />}
                                endMessage={
                                    <>
                                        <div style={{ textAlign: 'center', width: '100%', margin: '2rem 0' }}>
                                            <b>...No More Data To Load...</b>
                                        </div>
                                    </>
                                }
                            >
                                {!search ? data && data.length > 0 ? data?.map((elm, i) => {
                                     const valArr = Array.isArray(value) ? value : (value ? [value] : []);
                                     const isChecked = valArr.some(v => {
                                         if (typeof v === 'object' && v !== null) {
                                             if (v[nameKey] && elm[nameKey] && String(v[nameKey]).trim().toLowerCase() === String(elm[nameKey]).trim().toLowerCase()) return true;
                                             const vId = v[valueKey] || v._id || v.id;
                                             if (vId && String(vId) === String(elm[valueKey])) return true;
                                         } else {
                                             if (String(v) === String(elm[valueKey])) return true;
                                         }
                                         return false;
                                     });
                                     return (
                                         <ListItemButton onClick={() => {
                                             if (multi) {
                                                 if (isChecked) {
                                                     const temp = valArr.filter(v => {
                                                         if (typeof v === 'object' && v !== null) {
                                                             if (v[nameKey] && elm[nameKey] && String(v[nameKey]).trim().toLowerCase() === String(elm[nameKey]).trim().toLowerCase()) return false;
                                                             const vId = v[valueKey] || v._id || v.id;
                                                             if (vId && String(vId) === String(elm[valueKey])) return false;
                                                         } else {
                                                             if (String(v) === String(elm[valueKey])) return false;
                                                         }
                                                         return true;
                                                     });
                                                     onChange(isSimpleArray ? name : {
                                                         target: {
                                                             name,
                                                             value: temp,
                                                             fullObject: elm
                                                         }
                                                     });
                                                 } else {
                                                     onChange(isSimpleArray ? name : {
                                                         target: {
                                                             name,
                                                             value: [...valArr, elm[valueKey]],
                                                             fullObject: elm
                                                         }
                                                     });
                                                 }
                                             } else {
                                                 onChange(isSimpleArray ? name : {
                                                     target: {
                                                         name,
                                                         value: elm[valueKey],
                                                         fullObject: elm
                                                     }
                                                 });
                                             }
                                             if (!multi) handleClick();
                                         }} key={i} sx={{ pl: 1, fontSize: "1rem" }}>
                                             {multi ? <Checkbox checked={isChecked} /> : null}
                                             < ListItemText sx={({ palette: { dark, error, info, white } }) => ({
                                                 '& .MuiTypography-root': {
                                                     fontWeight: '400',
                                                     fontSize: "14px",
                                                     color: !darkMode ? dark.main : white.main,
                                                 }
                                             })} primary={elm[nameKey]}
                                             />
                                         </ListItemButton>
                                     );
                                 })
                                     : <ListItemButton onClick={() => {
                                         if (!multi) handleClick();
                                     }} sx={{ pl: 1 }}>
                                         <ListItemText sx={({ palette: { dark, error, info, white } }) => ({
                                             '& .MuiTypography-root': {
                                                 color: !darkMode ? dark.main : white.main,
                                             }
                                         })} primary={'Sorry No Data To Show'} />
                                     </ListItemButton>
                                     : filterData && filterData?.length ? filterData?.map((elm, i) => {
                                         const valArr = Array.isArray(value) ? value : (value ? [value] : []);
                                         const isChecked = valArr.some(v => {
                                             if (typeof v === 'object' && v !== null) {
                                                 if (v[nameKey] && elm[nameKey] && String(v[nameKey]).trim().toLowerCase() === String(elm[nameKey]).trim().toLowerCase()) return true;
                                                 const vId = v[valueKey] || v._id || v.id;
                                                 if (vId && String(vId) === String(elm[valueKey])) return true;
                                             } else {
                                                 if (String(v) === String(elm[valueKey])) return true;
                                             }
                                             return false;
                                         });
                                         return (
                                             <ListItemButton onClick={() => {
                                                 if (multi) {
                                                     if (isChecked) {
                                                         const temp = valArr.filter(v => {
                                                             if (typeof v === 'object' && v !== null) {
                                                                 if (v[nameKey] && elm[nameKey] && String(v[nameKey]).trim().toLowerCase() === String(elm[nameKey]).trim().toLowerCase()) return false;
                                                                 const vId = v[valueKey] || v._id || v.id;
                                                                 if (vId && String(vId) === String(elm[valueKey])) return false;
                                                             } else {
                                                                 if (String(v) === String(elm[valueKey])) return false;
                                                             }
                                                             return true;
                                                         });
                                                         onChange(isSimpleArray ? name : {
                                                             target: {
                                                                 name,
                                                                 value: temp,
                                                                 fullObject: elm
                                                             }
                                                         });
                                                     } else {
                                                         onChange(isSimpleArray ? name : {
                                                             target: {
                                                                 name,
                                                                 value: [...valArr, elm[valueKey]],
                                                                 fullObject: elm
                                                             }
                                                         });
                                                     }
                                                 } else {
                                                     onChange(isSimpleArray ? name : {
                                                         target: {
                                                             name,
                                                             value: elm[valueKey],
                                                             fullObject: elm
                                                         }
                                                     });
                                                 }

                                                 if (!multi) handleClick();
                                             }} key={i} sx={{ pl: 1 }}>
                                                 {multi ? <Checkbox checked={isChecked} /> : null}
                                                <ListItemText sx={({ palette: { dark, error, info, white } }) => ({
                                                    '& .MuiTypography-root': {
                                                        fontWeight: '400',
                                                        fontSize: "14px",
                                                        color: !darkMode ? dark.main : white.main,
                                                    }
                                                })} primary={elm[nameKey]} />
                                            </ListItemButton>
                                        );
                                    })
                                        : <ListItemButton onClick={() => {
                                            if (!multi) handleClick()
                                        }} sx={{ pl: 1 }}>
                                            <ListItemText sx={({ palette: { dark, error, info, white } }) => ({
                                                '& .MuiTypography-root': {
                                                    color: !darkMode ? dark.main : white.main,
                                                }
                                            })} primary={'Sorry No Data To Show'} />
                                        </ListItemButton>}
                            </InfiniteScroll>}
                        </List>
                    </Box>
                </Collapse>
                </List >
            </div >
        </>
    );
};

export default InfiniteApnaSelect;

InfiniteApnaSelect.propTypes = {
    value: PropTypes.any,
    name: PropTypes.any,
    onChange: PropTypes.any,
    origin: PropTypes.any,
    valueKey: PropTypes.any,
    nameKey: PropTypes.any,
    isSimpleArray: PropTypes.any,
    fetchApi: PropTypes.any,
    collpaseHeight: PropTypes.any,
    multi: PropTypes.any,
    fetchApiParams: PropTypes.any,
    defaultName: PropTypes.any,
};